<template>
  <v-app-bar color="#F6F6F6" elevation="0">
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <a
          class="logout-link"
          :href="logoutURL"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon dense>mdi-logout</v-icon>
        </a>
      </template>
      <span>Sair</span>
    </v-tooltip>
    <img
      :src="require('@/assets/img/logo_verde.png')"
      class="ma-auto logo-size"
      alt="Logo Plataforma Telessaúde"
    >
  </v-app-bar>
</template>

<script>
export default {
  name: 'HeaderNav',
  computed: {
    logoutURL() {
      return process.env.VUE_APP_URL_PLATA + '/accounts/logout/';
    }
  }
}
</script>

<style scoped>
.logout-link {
  line-height: 0;
  padding: 3px;
}
.logout-height { height: 25px; }
.logo-size { width: 218px; }
</style>
